import React from 'react';

const Biography = () => {
    return (
        <div>
            <div className="image-section">
                <img className="biography-image" src={'https://lorraineshemeshsiteimgs2.s3.us-east-2.amazonaws.com/book_SpaceBetweenUs_2.jpg'} alt="Lorraine Shemesh: The Space Between Us book"/>
            </div>
            <div className="biography-section-type">
                <p className="biography-type-title"><b>Education</b></p>
                <div className="biography-year-group">
                    <p className="biography-year"><b>1973</b></p>
                    <div className="biography-container">
                        <p><b>Tyler School of Art</b>, M.F.A. Painting.</p>
                        <p>Elkins Park, Pennsylvania.</p>
                    </div>
                </div>
                <div className="biography-year-group">
                    <p className="biography-year"><b>1971-72</b></p>
                    <div className="biography-container">
                        <p className="biography-listing"><b>Tyler School of Art in Rome</b>.</p>
                        <p>Rome, Italy.</p>
                    </div>
                </div>
                <div className="biography-year-group">
                    <p className="biography-year"><b>1971</b></p>
                    <div className="biography-container">
                        <p className="biography-listing"><b>Boston University</b>, B.F.A. Painting, Magna Cum Laude.</p>
                        <p>Boston, Massachusetts.</p>
                    </div>
                </div>
            </div>

            <div className="biography-section-type">
                <p className="biography-type-title"><b>Teaching Experience</b></p>
                <div className="biography-year-group">
                    <p className="biography-year"><b>1980-81</b></p>
                    <div className="biography-container">
                        <p className="biography-listing"><b>Amherst College</b>, Amherst, Massachusetts.</p>
                        <p>Assistant Professor of Fine Arts.</p>
                    </div>
                </div>
                <div className="biography-year-group">
                    <p className="biography-year"><b>1973-80</b></p>
                    <div className="biography-container">
                        <p className="biography-listing"><b>Rhode Island School of Design</b>, Providence, Rhode Island.</p>
                        <p>Assistant Professor of Fine Arts.</p>
                    </div>
                </div>
            </div>

            <div className="biography-section-type">
                <p className="biography-type-title"><b>Awards</b></p>
                <div className="biography-year-group">
                    <p className="biography-year"><b>2021</b></p>
                    <div className="biography-container">
                        <p className="biography-listing"><b>Dartmouth College</b> - Artist-in-Residence.</p>
                    </div>
                </div>
                <div className="biography-year-group">
                    <p className="biography-year"><b>2005</b></p>
                    <div className="biography-content-right">
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>National Academy of Design</b> - Elected For Membership.</p>
	                    </div>
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>Watershed</b> - Fellowship, Newcastle, Maine.</p>
	                    </div>
	                </div>
                </div>
                <div className="biography-year-group">
                    <p className="biography-year"><b>2000</b></p>
                    <div className="biography-container">
                        <p className="biography-listing"><b>Watershed</b> - Fellowship, Newcastle, Maine.</p>
                    </div>
                </div>
                <div className="biography-year-group">
                    <p className="biography-year"><b>1999</b></p>
                    <div className="biography-container">
                        <p className="biography-listing"><b>Fire & Form Symposium</b> - Residency, Burgstein, Austria.</p>
                    </div>
                </div>
                <div className="biography-year-group">
                    <p className="biography-year"><b>1996</b></p>
                    <div className="biography-container">
                        <p className="biography-listing"><b>NEA/MAAF Regional Fellowship</b>, Painting Finalist.</p>
                    </div>
                </div>
                <div className="biography-year-group">
                    <p className="biography-year"><b>1992</b></p>
                    <div className="biography-container">
                        <p className="biography-listing"><b>Distinguished Alumni Award</b>, School of Visual Arts, Boston University.</p>
                    </div>
                </div>
                <div className="biography-year-group">
                    <p className="biography-year"><b>1981</b></p>
                    <div className="biography-content-right">
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>Yaddo</b> - Fellowship.</p>
	                    </div>
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>Outstanding Service Award</b>, Amherst College.</p>
	                    </div>
	                </div>
                </div>
                <div className="biography-year-group">
                    <p className="biography-year"><b>1979</b></p>
                    <div className="biography-container">
                        <p className="biography-listing"><b>Rhode Island State Council for the Arts Grant</b>, Painting.</p>
                    </div>
                </div>
                <div className="biography-year-group">
                    <p className="biography-year"><b>1972-73</b></p>
                    <div className="biography-container">
                        <p className="biography-listing"><b>Fellowship in Painting</b>, Tyler School of Art.</p>
                    </div>
                </div>
                <div className="biography-year-group">
                    <p className="biography-year"><b>1971-72</b></p>
                    <div className="biography-container">
                        <p className="biography-listing"><b>Scholarship in Painting</b>, Tyler School of Art in Rome.</p>
                    </div>
                </div>
                <div className="biography-year-group">
                    <p className="biography-year"><b>1971</b></p>
					<div className="biography-content-right">
						<div className="biography-container">
	                        <p className="biography-listing"><b>Prize in Painting</b>, Boston University.</p>
	                    </div>
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>Prize in Printmaking</b>, Boston University.</p>
	                    </div>
	                </div>
                </div>
                <div className="biography-year-group">
                    <p className="biography-year"><b>1970</b></p>
                    <div className="biography-content-right">
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>Prize in Painting</b>, Boston University.</p>
	                    </div>
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>Case Merit Scholarship</b>, Boston University.</p>
	                    </div>
	                </div>
                </div>
                <div className="biography-year-group">
                    <p className="biography-year"><b>1969</b></p>
                    <div className="biography-content-right">
                    	<div className="biography-container">
	                        <p className="biography-listing"><b>Tanglewood Scholarship</b>, Boston University.</p>
	                    </div>
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>Julius Rosen Scholarship</b>, Boston University.</p>
	                    </div>
	                </div>
                </div>
            </div>

            <div className="biography-section-type">
                <p className="biography-type-title"><b>Selected Public Collections</b></p>
                <div className="biography-year-group">
                	<div className="biography-content-left">
                        <div className="biography-container">
	                        <p className="biography-listing"><b>Hood Museum of Art</b>, Hanover, New Hampshire.</p>
	                    </div>
                        <div className="biography-container">
	                        <p className="biography-listing"><b>Danforth Museum</b>, Framingham, Massachusetts.</p>
	                    </div>
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>Marie Josée Kravis</b>, President, Museum of Modern Art (MOMA), New York, New York.</p>
	                    </div>
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>Gerald Peters Collection</b>, Santa Fe, New Mexico.</p>
	                    </div>
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>Hall Collection</b>, Southport, Connecticut.</p>
	                    </div>
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>Allan Stone Collection</b>, Purchase, New York.</p>
	                    </div>
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>The Butler Institute of American Art</b>, Youngstown, Ohio.</p>
	                    </div>
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>National Academy Museum</b>, New York, New York.</p>
	                    </div>
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>Boise Art Museum</b>, Boise, Idaho.</p>
	                    </div>
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>DeCordova Museum</b>, Lincoln, Massachusetts.</p>
	                    </div>
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>Museum of The City of New York</b>, New York, New York.</p>
	                    </div>
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>Museum of The Rhode Island School of Design</b>, Providence, Rhode Island.</p>
	                    </div>
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>American Telephone and Telegraph</b>, Chicago, Illinois.</p>
	                    </div>
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>Morgan Stanley Dean Whitter</b>, New York, New York.</p>
	                    </div>
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>Nationsbanc Montgomery Securities</b>, Charlotte, North Carolina.</p>
	                    </div>
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>Montgomery Asset Management</b>, San Francisco, California.</p>
	                    </div>
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>Novartis Corporation</b>, Basel, Switzerland</p>
	                    </div>
	                </div>
                </div>
            </div>

			<div className="biography-section-type">
                <p className="biography-type-title"><b>Visiting Artist</b></p>
                <div className="biography-year-group">
                	<div className="biography-content-left">
						<div className="biography-container">
	                        <p className="biography-listing"><b>Maryland Institute College of Art</b>, Baltimore, MD.</p>
	                    </div>
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>University of New Hampshire</b>, Durham, NH.</p>
	                    </div>
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>Marie Walsh Sharpe Art Foundation</b>, Colorado Springs, CO.</p>
	                    </div>
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>Middlebury College</b>, Middlebury, VT.</p>
	                    </div>
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>National Academy of Design School</b>, New York, NY.</p>
	                    </div>
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>Bloomsburg University of Pennsylvania</b>, Bloomsburg, PA.</p>
	                    </div>
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>Boston University</b>, Boston, MA.</p>
	                    </div>
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>Salve Regina College</b>, Newport, RI.</p>
	                    </div>
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>Lincoln Center Institute</b>, New York, NY.</p>
	                    </div>
	                    <div className="biography-container">
	                        <p className="biography-listing"><b>Watershed Center for the Ceramic Arts</b>, Newcastle, ME</p>
	                    </div>
                	</div>
                </div>
            </div>

        </div>)
}

export default Biography;